import React, { useState } from 'react';
import logo from '../images/logo.png'
import { Link } from "react-router-dom";
import PropTypes from 'prop-types'
import DropdownButton from './DropdownButton';


export default function Navbar(props) {
  const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
  return (
<>
<div className="fixed w-full z-20 top-0 start-0 ">
<div className=" blueline bg-blue-900 mx-0 lg:h-8 sm:h-12 ">
<section className='lg:flex sm:flex-none'>
  <div className="flex ">
<svg xmlns="http://www.w3.org/2000/svg" className='w-4 ml-10' fill="white" viewBox="0 0 32 32" id="phone"><path d="M23.45 20.93a3 3 0 0 0-4.25 0l-1.45 1.45a26.14 26.14 0 0 1-4.51-3.62 26.62 26.62 0 0 1-3.62-4.51l1.45-1.45a3 3 0 0 0 0-4.25L8.24 5.73a2.93 2.93 0 0 0-2.11-.88h0A3 3 0 0 0 4 5.73L2.64 7.08A6.37 6.37 0 0 0 1 12.33c.32 3.75 2.78 8.26 6.57 12.06S15.92 30.64 19.67 31a7.87 7.87 0 0 0 .84 0 6.07 6.07 0 0 0 4.41-1.64L26.27 28a3 3 0 0 0 .88-2.13 2.93 2.93 0 0 0-.88-2.11zm1.41 5.66L23.5 27.94a4.57 4.57 0 0 1-3.66 1c-3.25-.28-7.39-2.58-10.81-6S3.31 15.41 3 12.16a4.53 4.53 0 0 1 1-3.66L5.41 7.14a1 1 0 0 1 .71-.29h0a1 1 0 0 1 .71.29L9.66 10a1 1 0 0 1 0 1.41l-2 2a1 1 0 0 0-.16 1.21 27.49 27.49 0 0 0 4.33 5.58 27.49 27.49 0 0 0 5.58 4.33 1 1 0 0 0 1.21-.16l2-2a1 1 0 0 1 1.41 0l2.83 2.83h0a1 1 0 0 1 .29.71A1 1 0 0 1 24.86 26.59zM26.6 5.39A14.92 14.92 0 0 0 16 1a1 1 0 1 0 0 2A13 13 0 0 1 29 16.11a1 1 0 0 0 1 1h0a1 1 0 0 0 1-1A14.91 14.91 0 0 0 26.6 5.39z"></path><path d="M20.91,11.11a6,6,0,0,1,1.77,4.31,1,1,0,0,0,1,1h0a1,1,0,0,0,1-1,8,8,0,0,0-8-8.1,1,1,0,1,0,0,2A6,6,0,0,1,20.91,11.11Z"></path></svg>
<h1 className='text-white text-sm ml-2 my-1 '>9320811878/9702551626/9320646432</h1>
</div>

<div className="flex">
<svg xmlns="http://www.w3.org/2000/svg" className='w-4 ml-10' fill="white" viewBox="0 0 128 96" id="email"><g data-name="Layer 2"><path d="M0 11.283V8a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8v3.283l-64 40zm66.12 48.11a4.004 4.004 0 0 1-4.24 0L0 20.717V88a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8V20.717z"></path></g></svg>
<h1 className='text-white text-sm ml-2 my-1'>jmmr2003@gmail.com</h1>
</div>
<div className="hidden xl:flex">
<svg className=' ml-96 mt-1' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px"  fill="white" viewBox="0 0 50 50">
                    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
            </svg>
            
            <svg class="ml-5 mt-1" aria-hidden="true"  width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 8 19">
                              <path fill-rule="evenodd" d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z" clip-rule="evenodd"/>
                  </svg>                  
                </div>   
</section>            
</div>


<nav class="bg-white  border drop-shadow-lg">

  <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
    <div class="relative flex h-16 items-center justify-between">
      <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">

        <button onClick={toggleDropdown} type="button" class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
          <span class="absolute -inset-0.5"></span>
          <span class="sr-only">Open main menu</span>
          {/* <!--
            Icon when menu is closed.

            Menu open: "hidden", Menu closed: "block"
          --> */}
          <svg class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
          {/* <!--
            Icon when menu is open.

            Menu open: "block", Menu closed: "hidden"
          --> */}
          <svg class="hidden h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
      </div>
      
      <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
        <div class="flex flex-shrink-0 items-center">
          <img class="h-20 mt-2 w-full" src={logo} alt="Your Company"/>
        </div>
        <div class="hidden  sm:ml-6 mt-6 sm:block absolute right-0">
          <div class="flex space-x-4 ">
            
            <Link 
            id="home"
            className={`${props.page === 'home' ? 'bg-gray-300' : 'bg-white-100' } text-black rounded-md px-3 py-2 text-sm font-medium`}
            to="/">
              Home
            </Link>
            <Link 
            id="About"
            className={`${props.page === 'aboutus' ? 'bg-gray-300' : 'bg-white-100 ' } text-black rounded-md px-3 py-2 text-sm font-medium hover:bg-gray-200`}
            to="/aboutus">
              About us
            </Link>
            <Link 
            id="Services"
            className={`${props.page === 'services' ? 'bg-gray-300' : 'bg-white-100' } text-black rounded-md px-3 py-2 text-sm font-medium hover:bg-gray-200`}
            to="/services">
              Services
            </Link>
            <Link 
            id="contact"
            className={`${props.page === 'contact' ? 'bg-gray-300' : 'bg-white-100' } text-black rounded-md px-3 py-2 text-sm font-medium hover:bg-gray-200`}
            to="/contact">
              Contact Us
            </Link>
            <Link 
            id="Ask"
            className={`${props.page === 'AskRate' ? 'bg-gray-300' : 'bg-white-100' } text-black rounded-md px-3 py-2 text-sm font-medium hover:bg-gray-200`}
            to="/askrate">
              Ask Rate
            </Link>
          </div>
        </div>
      </div>
      <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">



      </div>
    </div>
  </div>
  {isOpen && (
                  <div class="sm:hidden"  id="mobile-menu">
                  <div class="space-y-1 px-2 pb-3 pt-2">
                    {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
                               <Link 
            id="home"
            className={`${props.page === 'home' ? 'bg-gray-300' : 'bg-white-100' } "text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium`}
            to="/">
              Home
            </Link>
            <Link 
            id="About"
            className={`${props.page === 'aboutus' ? 'bg-gray-300' : 'bg-white-100' } "text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium`}
            to="/aboutus">
              About us
            </Link>
            <Link 
            id="Services"
            className={`${props.page === 'services' ? 'bg-gray-300' : 'bg-white-100' } "text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium`}
            to="/services">
              Services
            </Link>
            <Link 
            id="contact"
            className={`${props.page === 'contact' ? 'bg-gray-300' : 'bg-white-100' } "text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium`}
            to="/contact">
              Contact Us
            </Link>
            <Link 
            id="Ask"
            className={`${props.page === 'AskRate' ? 'bg-gray-300' : 'bg-white-100' } "text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium`}
            to="/askrate">
              Ask Rate
            </Link>
                  </div>
                </div>
            )}

  
  
    
</nav>
</div>
</>
  )
}

Navbar.propTypes = {
  page: PropTypes.string,
}

Navbar.defaultProps = {
  page: 'home',
}